<script setup lang="ts">
    import Task from '~/app/task/models/Task';
    import PlanningItem from '~/app/planning/models/PlanningItem';

    const props = defineProps<{
        planningItem: PlanningItem;
        model: Task;
        displayTime: boolean;
    }>();
</script>

<template>
    <div
        :id="model.getInternalId()"
        class="flex items-center p-2 mb-1 space-x-2 text-xs text-gray-800 bg-white border rounded border-neutral-200"
        @click.prevent="model.edit()"
    >
        <TaskTaskItemCheck :task="model" />
        <span class="overflow-hidden text-ellipsis">
            {{ model.title }}
        </span>
    </div>
</template>
